import React from 'react';

import type { Athlete } from './athletes';
import { SPONSORS_MARQUEE_THRESHOLD } from './athletes';

type AthleteInfoPanelProps = {
    athlete: Athlete;
};

export function AthleteInfoPanel({ athlete }: AthleteInfoPanelProps) {
    const scrolling = athlete.sponsors.length > SPONSORS_MARQUEE_THRESHOLD;

    const renderSponsorChips = () => athlete.sponsors.map((logo, index) => (
        <span key={`${logo}-${index}`} className="info-panel__sponsor" aria-hidden="true">
            <img src={logo} alt="" loading="lazy" decoding="async" />
        </span>
    ));

    return (
        <div className="info-panel">
            <div className="info-panel__top">
                <div className="info-panel__sport-row">
                    <span className="info-panel__sport-dot" aria-hidden="true" />
                    <span className="info-panel__sport-label faves-eyebrow">{athlete.sport}</span>
                </div>
                <div className="info-panel__name faves-h3">{athlete.name}</div>
            </div>
            <div
                className={`info-panel__sponsors${scrolling ? ' info-panel__sponsors--scrolling' : ''}`}
                aria-label={`${athlete.name} sponsors`}
            >
                <div className="info-panel__sponsors-track">
                    {renderSponsorChips()}
                    <div className="info-panel__sponsors-clone" aria-hidden="true">
                        {renderSponsorChips()}
                    </div>
                </div>
            </div>
        </div>
    );
}
